import { z } from 'zod';
import { ConversationIdSchema, ScheduledTaskRunIdSchema } from '../ids.ts';
import { ScheduledTaskViewSchema, TaskRunStatusSchema } from '../tools/scheduled-tasks.ts';

export const ScheduledTaskSchema = ScheduledTaskViewSchema.extend({
  object: z.literal('scheduled_task'),
  unread: z.number().int().nonnegative(),
});
export type ScheduledTask = z.infer<typeof ScheduledTaskSchema>;

export const ScheduledTaskListResponseSchema = z.object({
  data: z.array(ScheduledTaskSchema),
});
export type ScheduledTaskListResponse = z.infer<typeof ScheduledTaskListResponseSchema>;

export const TaskRunSchema = z.object({
  id: ScheduledTaskRunIdSchema,
  object: z.literal('scheduled_task.run'),
  status: TaskRunStatusSchema,
  occurrence_at: z.string(),
  started_at: z.string(),
  ended_at: z.string().nullable(),
  summary: z.string().nullable(),
  problems: z.array(z.string()),
  conversation_id: ConversationIdSchema.nullable(),
  unread: z.boolean(),
});
export type TaskRun = z.infer<typeof TaskRunSchema>;

export const ScheduledTaskDetailSchema = ScheduledTaskSchema.extend({
  runs: z.array(TaskRunSchema),
});
export type ScheduledTaskDetail = z.infer<typeof ScheduledTaskDetailSchema>;

export const ScheduledTaskDeletedSchema = z.object({
  id: z.string(),
  object: z.literal('scheduled_task.deleted'),
  deleted: z.literal(true),
});
export type ScheduledTaskDeleted = z.infer<typeof ScheduledTaskDeletedSchema>;

export const UnreadCountSchema = z.object({
  object: z.literal('unread_count'),
  count: z.number().int().nonnegative(),
});
export type UnreadCount = z.infer<typeof UnreadCountSchema>;
